import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@optiaxiom/react';

import { RUNTIME_ENV } from '@frontend/envConfig';
import { OpalChatOverlay } from '@frontend/features/chat/components/OpalChatOverlay';
import { LeftNavbar } from '@frontend/features/leftNavbar';
import { useRouteDocumentTitle } from '@frontend/hooks/useDocumentTitle';
import { useNotificationEvents } from '@frontend/hooks/useNotificationEvents';
import { useOpalUser } from '@frontend/hooks/useOpalUser';

import { baseLayoutStyles, mainContentStyles } from './BaseLayout.css';
import { RightSidebarHost } from './RightSidebarHost';

export function BaseLayout() {
  const { opalUser } = useOpalUser();
  useRouteDocumentTitle();
  useNotificationEvents();

  useEffect(() => {
    if (!opalUser) {
      return;
    }

    if (RUNTIME_ENV === 'production' || RUNTIME_ENV === 'integration') {
      void import(/* webpackChunkName: "Userflow" */ '@frontend/userflow').then(
        ({ default: Userflow }) => {
          Userflow.init(opalUser, opalUser.userflow_token);
        }
      );
    }
  }, [opalUser]);

  return (
    <Box className={baseLayoutStyles}>
      <LeftNavbar />
      <Box className={mainContentStyles}>
        <Outlet />
      </Box>
      <RightSidebarHost />
      <OpalChatOverlay />
    </Box>
  );
}
